import { Navigate, useLocation } from "react-router-dom";

export default function CompensationProfilesEditRedirect() {
  const location = useLocation();
  // Redirect from /people/:pgaId/career/compensation-profiles/:compProfileId/edit to /people/:pgaId/career/compensation/:compProfileId/edit
  const newPath = location.pathname.replace("/compensation-profiles/", "/compensation/");
  return <Navigate to={`${newPath}${location.search}`} replace />;
}
